export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/create-scratch.2aa727aa.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};